<!-- Outer page: white background -->
<div class="hp-outer-page">
  <div class="hp-phone-frame">
    <main class="hp-main" role="main">

      <div class="hp-input-area">

        <!-- Card header: spacer + centered title + spacer -->
        <div class="hp-card-header">
          <div class="hp-spacer"></div>
          <h2 class="hp-nav-title">パスワードの再設定</h2>
          <div class="hp-spacer"></div>
        </div>

        <!-- Success section -->
        <div class="hp-sent-body">

          <!-- Success header: green checkmark + title -->
          <div class="hp-success-header">
            <div class="hp-success-icon" aria-hidden="true">
              <!-- Green checkmark circle matching Figma Success/700: #2DB54E -->
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="16" fill="#2DB54E"/>
                <path d="M9 16.5L13.5 21L23 11.5" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p class="hp-success-title">ご案内メールをお送りしました</p>
          </div>

          <!-- Info box: gray background (#E7E7E7) -->
          <div class="hp-info-tooltip">
            <div class="hp-info-tooltip__header">
              <!-- Info icon -->
              <div class="hp-info-tooltip__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#6B6B6B" stroke-width="2"/>
                  <path d="M12 11v6" stroke="#6B6B6B" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="12" cy="8" r="1" fill="#6B6B6B"/>
                </svg>
              </div>
              <strong class="hp-info-tooltip__title">メールが届かない場合</strong>
            </div>
            <p class="hp-info-tooltip__text">
              dx-utility.comのドメインからメールが届きます。認証メールが届かない場合は、迷惑メールフォルダに入る設定となっていないかご確認ください。
            </p>
          </div>

        </div>
      </div>

    </main>
  </div>
</div>
